import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Account } from '../../../models/AccountModel';
import { PlatformApiService } from '../../../services/platform-api.service';
import { ChartQuarters } from 'src/app/services/platform-api-types';
import * as moment from 'moment';

@Component({
  selector: 'app-assessment-status-by-quarter',
  templateUrl: './assessment-status-by-quarter.component.html',
  styleUrls: ['./assessment-status-by-quarter.component.scss']
})
export class AssessmentStatusByQuarterComponent implements OnInit {

  @ViewChild('myCanvas', { static: true }) canvas: ElementRef;
  @Input() parentAccount:Account
  histogram = [];

  constructor(private _platformApi: PlatformApiService) { }

  gradient = ['#5bba47','#74c463', '#8ccf7e', '#addda3'];

  public barChartOptions:any = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
          scaleLabel: {
              display: false,
              labelString: 'Quarter'
          },
          gridLines: {
              display: false,
              drawTicks: false
          },
          ticks: {
              min: 0,
              max: 100,
              display: true
          }
      }],
      yAxes: [{
          scaleLabel: {
              display: false,
              labelString: 'Count'
          },
          gridLines: {
              display: false,
              drawTicks: false
          },
          ticks: {
              display: false
          }
      }]
    },
  };


  public barChartLabels: string[] = ['Q3 2017', 'Q4 2017', 'Q1 2018', 'Q2 2018'];
  public barChartStatusLabels: string[] = ['Total', 'Not Started', 'In Progress', 'Completed'];
  public barChartType = 'bar';
  public barChartLegend = false;
  public barChartColors:Array<any>;

  public barChartData: any[] = [
    { data: [], label: 'Total' },
    { data: [], label: 'Not Started' },
    { data: [], label: 'In Progress' },
    { data: [], label: 'Completed' }
  ];
  private _barChartData: any[] = [
    {data: [], label: 'Total'},
    {data: [], label: 'Not Started'},
    {data: [], label: 'In Progress'},
    {data: [], label: 'Completed'}
  ];

  ngOnInit() {
    this.barChartLabels = new ChartQuarters(new Date(), 4).quarters.reverse();
    for (let i=0; i<4; i++) {
      const notStarted = 0;
      const inProgress = 0;
      const completed  = 0;
      this._barChartData[0].data[i] = notStarted + inProgress + completed;
      this._barChartData[1].data[i] = notStarted;
      this._barChartData[2].data[i] = inProgress;
      this._barChartData[3].data[i] = completed;
    }
    this.barChartColors = [{
      backgroundColor: this.gradient[0],
      hoverBackgroundColor: this.gradient[0],
      hoverBorderColor: '#1a3047',
      hoverBorderWidth: 1
     },{
      backgroundColor: this.gradient[1],
      hoverBackgroundColor: this.gradient[1],
      hoverBorderColor: '#1a3047',
      hoverBorderWidth: 1
     },{
      backgroundColor: this.gradient[2],
      hoverBackgroundColor: this.gradient[2],
      hoverBorderColor: '#1a3047',
      hoverBorderWidth: 1
     },{
      backgroundColor: this.gradient[3],
      hoverBackgroundColor: this.gradient[3],
      hoverBorderColor: '#1a3047',
      hoverBorderWidth: 1
     } ];

     const tomorrow = moment().add(1, 'days');
     this._platformApi.getAssessmentStatusChartData(this.parentAccount.id, tomorrow.toDate()).subscribe(data => {
       if (Array.isArray(data)) {
         data.forEach(row => {
           const statusInx = this.barChartStatusLabels.indexOf(row.status);
           const qtrInx = this.barChartLabels.indexOf(row.qtrYear);
           this._barChartData[0].data[qtrInx] += row.total;
           this._barChartData[statusInx].data[qtrInx] = row.total;
         });
       }
       this.barChartData = this._barChartData;
       this.barChartData.slice();
     });
  }
}


